module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jaVTMUrFQBBdhIB8EDyCYCO5gQfwDF7CXrD5za9+EYjn8ATBI6SMtu+9JkuIv0lhY2Rt9oe4f3cLHZhq3ryZeTNjTGDW2pJkRbIDMAGYSHYkK2ttGeIXc84VkmoAMwCX8FlS7ZwrTpIBNGGCpO04jheSHoNY84vEVz6p6Jzb+AKbCHm9njnaNsknAJeStrFxrLWlIVllZs46ycp4tWPBfd/3NwDOAdwD+I5gOuNXFSM4SHo+6gTgPYKbkgSe5MGLeEbyI0qQGsH7lTHGkLxNFOhyIr4d2ye5S4qYWiPJ1xXBC8mvADMvp504pE9Jd23bFsMwXJPcr+PLIeVOOeNN9B/+/Ez/eecf1Q3kaP+Qxi8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/detail.png
// module id = G8/A
// module chunks = 17